<template>
	<div style="height: calc(100vh - 120px);">
		<buttonlist @save="save" ref="SetBtn"></buttonlist>
		<div style="display: flex;width: 100%;height:100%;margin-top: 2px">
			<div style="width:25%;height:100%">
				<el-scrollbar style="height:100%;width: 100%;">
					<el-tree :data="dataTree" :props="defaultProps" default-expand-all="true" @node-click="handleNodeClick"></el-tree>
				</el-scrollbar>
			</div>
			<div style="width:74%">
				<el-transfer
						ref="transfer"
						:titles="[$t('getapi[13361]'), $t('getapi[13362]')]"
						v-model="value"
						:data="sortedData"
						@left-check-change="handleLeftCheckChange"
						@change="handleChange"
						class="draggable-transfer">
					<el-button type="primary" class="transfer-footer" slot="left-footer" size="mini" @click="editAbstract" :disabled="leftSelectedData.length != 1 || leftSelectedData[0].name.indexOf('自定义摘要') === -1">{{$t('getapi[34]')}}{{$t('getapi[7340]')}}</el-button>
				</el-transfer>
			</div>
		</div>

		<el-dialog :title="$t('getapi[34]')" :visible.sync="dialogVisible" min-width=400px width=18%>
			<el-divider></el-divider>
			<div :style="{border:'1px solid #DCDFE6'}">
				<table>
					<tr>
						<td>{{$t('getapi[3306]')}}</td>
						<td><el-input v-model="customAbstract.name" type="text" size="mini" :disabled="true"></el-input></td>
					</tr>
					<tr>
						<td>{{$t('getapi[7371]')}}</td>
						<td><el-input v-model="customAbstract.value" type="text" size="mini"></el-input></td>
					</tr>
				</table>
			</div>
			<el-divider></el-divider>

			<span slot="footer" class="dialog-footer">
                <el-button size="small" @click="dialogVisible = false">{{$t('getapi[2054]')}}</el-button>
                <el-button size="small" type="primary" @click="confirmEditAbstract">{{$t('getapi[1146]')}}</el-button>
            </span>
		</el-dialog>
	</div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';
    import { encryptDes, decryptDes,generatekey } from '@/utils/des.js'

    export default {
        name: '3_purinvoiceabstract',
        data() {
            const generateData = _ => {
                const data = [];
                return data;
            }
            return {
                value: [],
                data: generateData(),
                rightarr: [], //右侧显示科目
                dataTree: [], // 角色分类树
                defaultProps: {
                    children: 'Children',
                    label: 'name',
                    num: 'num'
                },
                code:'',
                // 存储右侧项目的显示顺序
                rightPanelOrder: [],
                originalData: [], // 原始数据备份
                leftSelectedData: [],//左侧被选中数据key
                customAbstract:{},
                dialogVisible: false,//自定义编辑弹窗
            };
        },
        computed: {
            // 计算排序后的数据
            sortedData() {
                if (!this.originalData.length) return this.data;

                // 左侧数据保持原顺序
                const leftData = this.originalData.filter(item =>
                    !this.value.includes(item.key)
                );

                // 右侧数据按照 rightPanelOrder 排序
                const rightData = [];
                this.rightPanelOrder.forEach(key => {
                    const item = this.originalData.find(item => item.key === key);
                    if (item) {
                        rightData.push(item);
                    }
                });

                // 合并数据
                return [...leftData, ...rightData];
            }
        },
        watch: {
            value(newVal) {
                // 当value变化时，同步更新rightPanelOrder
                if (newVal.length !== this.rightPanelOrder.length) {
                    this.handleSelectionChange(newVal);
                }
                this.$nextTick(() => {
                    this.initDrag();
                });
            },
            data(newData) {
                // 当data变化时，备份原始数据
                if (newData.length > 0) {
                    this.originalData = [...newData];
                }
            }
        },
        mounted: function() {
            let that = this
            that.authority()
            that.init()
        },
        activated() {

        },
        methods: {
            authority(){
                let that = this
                that.$refs.SetBtn.SetButtonEnable('save');
            },
            init(){
                let that = this
                that.dataTree = [{
                    name: "",
                    num: "",
                    Children: []
                }]
                let tree = []
                tree.push({
                    name: that.$t('getapi[3836]'),
                    num : 1,
                    Children: []
                })
                that.dataTree[0].name = that.$t('getapi[13363]') // 凭证摘要设置
                that.dataTree[0].num = ""
                that.dataTree[0].Children = tree
            },
            handleNodeClick(data){
                let that = this
                console.log(data)
                that.code = data.name
                that.getAbstract(data.name)
                /*if(data.name == that.$t('getapi[12010]')){
                    const newData = [{
                        key:1,
                        label:that.$t('getapi[3682]') //发票类型
                    },{
                        key:2,
                        label:that.$t('getapi[2992]') //发票号
                    },{
                        key:3,
                        label:that.$t('getapi[3691]') //制单日期
                    },{
                        key:4,
                        label:that.$t('getapi[2692]') //客户编码
                    },{
                        key:5,
                        label:that.$t('getapi[13364]') //部门编码
                    },{
                        key:6,
                        label:that.$t('getapi[2598]') //销售员
                    },{
                        key:7,
                        label:that.$t('getapi[546]') //项目名称
                    },{
                        key:8,
                        label:that.$t('getapi[7222]') //发票号摘要
                    }];
				    that.data = newData;
                    this.originalData = [...newData];
                    // 初始化右侧面板顺序
                    this.rightPanelOrder = [...this.value];
				    }*/
            },
            getAbstract(name){
                let that = this
                let parm = {
                    Code:name
                }
                that.$http.urlpost('GL/Receive/GetAbstract', parm, function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.originalData = [];
                        that.rightPanelOrder= [];
                        that.value = []
                        let arr = [];
                        for (let i = 0; i < res.DataContent.length; i++) {
                            that.originalData.push({
                                Exclusively_ID: res.DataContent[i].Exclusively_ID,
                                key:res.DataContent[i].pending_sort,
                                label:res.DataContent[i].name + (res.DataContent[i].value==null?'':res.DataContent[i].value),
                                name:res.DataContent[i].name,
                                value:res.DataContent[i].value,
                            });
                            if (res.DataContent[i].selected_projects_flag  == 1) {
                                arr.push({
                                    key:res.DataContent[i].selected_sort,
                                    value:res.DataContent[i].pending_sort
                                });
                            }
                        }
                        that.originalData.sort((a, b) => a.key - b.key);
                        arr.sort((a, b) => a.key - b.key);
                        for(let i=0;i<arr.length;i++){
                            that.value.push(arr[i].value)
                        }
                    }
                })
            },
            //左侧数据被选中
            handleLeftCheckChange(selectedKeys){
                let that = this
                let leftSelectedKeys = selectedKeys
                that.leftSelectedData = that.sortedData.filter(item =>
                    selectedKeys.includes(item.key)
                );
                console.log(that.leftSelectedData)
            },
            //编辑自定义摘要
            editAbstract(){
                let that = this
                that.customAbstract = {
                    Exclusively_ID: that.leftSelectedData[0].Exclusively_ID,
                    name:that.leftSelectedData[0].name,
                    value:that.leftSelectedData[0].value
                }
                that.dialogVisible = true
            },
            confirmEditAbstract(){
                let that = this
                let parm = {
                    Exclusively_ID : that.customAbstract.Exclusively_ID,
                    value:that.customAbstract.value
                }
                that.$http.urlpost('GL/Receive/SaveCustomAbstract', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.dialogVisible = false
                        //that.getAbstract(that.code)
                        const item = that.sortedData.forEach(item => {
                            if (item.name === that.customAbstract.name) {
                                item.value = that.customAbstract.value
                                that.$set(item, 'label', that.customAbstract.name + that.customAbstract.value);
                            }
                        });
                    }
                })
            },
            handleChange(value, direction, movedKeys){
                let that = this
                that.rightarr = value

                // 处理右侧面板顺序
                if (direction === 'right') {
                    // 添加到右侧时，将新项目添加到顺序数组末尾
                    this.rightPanelOrder = [...this.rightPanelOrder, ...movedKeys];
                } else if (direction === 'left') {
                    // 从右侧移除时，从顺序数组中删除
                    this.rightPanelOrder = this.rightPanelOrder.filter(key => !movedKeys.includes(key));
                }
            },

            handleSelectionChange(newVal) {
                if (newVal.length > this.rightPanelOrder.length) {
                    // 新增项目
                    const addedItems = newVal.filter(item => !this.rightPanelOrder.includes(item));
                    this.rightPanelOrder = [...this.rightPanelOrder, ...addedItems];
                } else {
                    // 删除项目
                    const removedItems = this.rightPanelOrder.filter(item => !newVal.includes(item));
                    this.rightPanelOrder = this.rightPanelOrder.filter(item => !removedItems.includes(item));
                }
            },

            // 初始化拖拽功能
            initDrag() {
                this.$nextTick(() => {
                    const rightPanel = this.getRightPanel();
                    if (!rightPanel) return;

                    // 清除现有事件
                    this.clearDragEvents(rightPanel);

                    // 设置拖拽事件
                    this.setupDragEvents(rightPanel);
                });
            },

            // 获取右侧面板
            getRightPanel() {
                return document.querySelector('.el-transfer-panel:last-child .el-transfer-panel__body .el-transfer-panel__list');
            },

            // 清除拖拽事件
            clearDragEvents(panel) {
                panel.removeEventListener('dragover', this.handleDragOver);
                panel.removeEventListener('drop', this.handleDrop);

                const items = panel.querySelectorAll('.el-checkbox');
                items.forEach(item => {
                    const label = item.closest('label');
                    if (label) {
                        label.removeEventListener('dragstart', this.handleDragStart);
                        label.removeEventListener('dragend', this.handleDragEnd);
                    }
                });
            },

            // 设置拖拽事件
            setupDragEvents(panel) {
                // 面板事件
                panel.addEventListener('dragover', this.handleDragOver);
                panel.addEventListener('drop', this.handleDrop);

                // 为每个列表项设置拖拽
                const items = panel.querySelectorAll('.el-checkbox');
                items.forEach((item, index) => {
                    const label = item.closest('label');
                    if (label) {
                        label.draggable = true;
                        label.classList.add('draggable-item');
                        // 使用rightPanelOrder中的索引
                        label.setAttribute('data-index', index);

                        label.addEventListener('dragstart', this.handleDragStart);
                        label.addEventListener('dragend', this.handleDragEnd);
                    }
                });
            },

            // 拖拽开始
            handleDragStart(e) {
                const index = parseInt(e.target.getAttribute('data-index'));
                this.draggedIndex = index;
                e.dataTransfer.setData('text/plain', index);
                e.target.classList.add('dragging');
                e.dataTransfer.effectAllowed = 'move';
            },

            // 拖拽结束
            handleDragEnd(e) {
                e.target.classList.remove('dragging');
                this.draggedIndex = -1;
            },

            // 拖拽经过
            handleDragOver(e) {
                e.preventDefault();
                e.dataTransfer.dropEffect = 'move';

                // 添加视觉反馈
                const target = this.getDragTarget(e.target);
                if (target) {
                    this.clearDragFeedback();
                    target.classList.add('drag-over');
                }
            },

            // 拖拽放置
            handleDrop(e) {
                e.preventDefault();
                this.clearDragFeedback();

                const fromIndex = this.draggedIndex;
                if (fromIndex === -1) return;

                const target = this.getDragTarget(e.target);
                if (!target) return;

                const toIndex = parseInt(target.getAttribute('data-index'));
                if (fromIndex === toIndex || toIndex === -1) return;

                // 重新排序右侧面板数据
                this.reorderRightPanel(fromIndex, toIndex);
            },

            // 获取拖拽目标
            getDragTarget(element) {
                let target = element;
                while (target && !target.classList.contains('draggable-item')) {
                    target = target.parentElement;
                    if (!target || target.classList.contains('el-transfer-panel__list')) break;
                }
                return target && target.classList.contains('draggable-item') ? target : null;
            },

            // 清除拖拽反馈
            clearDragFeedback() {
                const items = document.querySelectorAll('.draggable-item');
                items.forEach(item => {
                    item.classList.remove('drag-over');
                });
            },

            // 重新排序右侧面板
            reorderRightPanel(fromIndex, toIndex) {
                // 创建新的顺序数组
                const newOrder = [...this.rightPanelOrder];
                const [movedItem] = newOrder.splice(fromIndex, 1);
                newOrder.splice(toIndex, 0, movedItem);

                // 更新顺序数组 - 这会触发 computed 属性更新，从而重新渲染
                this.rightPanelOrder = newOrder;

                // 同时更新value以保持同步
                this.value = [...newOrder];

                // 强制重新渲染穿梭框
                this.forceRerender();
            },

            // 强制重新渲染穿梭框
            forceRerender() {
                // 通过修改key来强制重新渲染组件
                this.$nextTick(() => {
                    // 重新初始化拖拽
                    this.initDrag();
                });
            },
            save(){
                let that = this
                let arr = []
                for(let i=0;i<that.originalData.length;i++){
                    arr = [...arr,{
                        type:'采购发票',
                        name:that.originalData[i].name,
                        value:that.originalData[i].value,
                        pending_sort:that.originalData[i].key,
                        selected_sort:'',
                        selected_projects_flag:'',
                    }]
                }
                for(let i=0;i<that.rightPanelOrder.length;i++){
                    for(let j=0;j<arr.length;j++){
                        if(that.rightPanelOrder[i] == arr[j].pending_sort){
                            arr[j].selected_projects_flag = 1
                            arr[j].selected_sort = i
                        }
                    }
                }
                let parm = arr
                that.$http.urlpost('GL/Receive/SaveAbstract', parm, function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                })
            }
        }
    };
</script>

<style scoped lang="less">
	table {
		border-collapse: separate;
		border-spacing: 0px 5px;

		td {
			padding-left: 3px;
			white-space: pre;
		}
	}
	.el-transfer{
		height:100%;
		/deep/.el-transfer-panel{
			height:100%;
		}
	}
	// 可拖动穿梭框样式
	.draggable-transfer {
		/deep/.el-transfer-panel {
			min-width: 250px;
			width:30%;
		}

		/deep/.el-transfer-panel__list {
			height:calc(100vh - 120px);
			min-height: 350px;
		}

		/deep/.draggable-item {
			cursor: move !important;
			padding: 8px 15px !important;
			border-bottom: 1px solid #ebeef5;
			transition: all 0.3s ease;
			display: flex !important;
			align-items: center;
			margin: 0 !important;
			user-select: none;

			&:hover {
				background-color: #f5f7fa !important;
			}

			&.dragging {
				background-color: #ecf5ff !important;
				border: 2px dashed #409EFF !important;
				border-radius: 4px;
				opacity: 0.8;
			}

			&.drag-over {
				background-color: #f0f9ff !important;
				border-top: 2px solid #409EFF !important;
			}

			.el-checkbox {
				width: 100%;
				pointer-events: none;
			}

			// 添加拖拽手柄图标
			&::before {
				content: "⠿";
				margin-right: 8px;
				color: #909399;
				font-size: 14px;
			}
		}
	}
</style>